import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  Spinner
} from "@chakra-ui/react";
import { Search2Icon } from "@chakra-ui/icons";
import { CleanFiltersIcon, IconSearch } from "~misc/icons";
import { useEffect, useState } from "react";

const RequestFilter = ({
  cleanFilters,
  setFilters,
  filters,
  totalList,
  total,
  loading,
  setLoading
}) => {
  const [internalValue, setInternalValue] = useState(filters.busca);

  const handleSearch = (e) => {
    e.preventDefault();
    setFilters({ ...filters, busca: internalValue })
    setLoading(true);
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    setInternalValue(inputValue);
    if (total < 1000) {
      setFilters({ ...filters, busca: inputValue })
      setLoading(true);
    }
  };

  const keyEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setFilters({ ...filters, busca: internalValue })
      setLoading(true);
    }
  }

  useEffect(() => {
    setInternalValue(filters.busca);
  }, [filters.busca]);

  return (
    <>
      <div className="bg-white p-5 border-terciaria border rounded-b-lg border-t-0">
        <div className="flex flex-col-reverse md:flex-row items-center gap-4 relative">
          <InputGroup size="lg" >
            <Input
              placeholder="Buscar solicitações"
              _placeholder={{ opacity: 1, color: "inherit", fontWeight: "400" }}
              className="input-filter-request"
              onChange={handleChange}
              value={internalValue}
              onKeyDown={keyEnter}
            />
            {/* <InputRightElement>
              <Search2Icon />
            </InputRightElement> */}

          </InputGroup>
          <button className="absolute top-50 right-0 p-4 z-2" type="button" onClick={handleSearch}>
            <IconSearch />
          </button>
        </div>
        <div className="flex flex-col md:flex-row items-center md:gap-2">
          <FormControl>
            <FormLabel className="mt-4 pl-1">
              Status da Solicitação:
            </FormLabel>
            <Select
              size="lg"
              className="select-filter-request focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value })
              }
              value={filters.status}
            >
              <option value="">Todos</option>
              <option value="1">Pendente</option>
              <option value="2">Concluído</option>
              <option value="3">Recusado</option>
              <option value="4">Erro</option>
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel className="mt-4 pl-1">Período:</FormLabel>
            <Select
              size="lg"
              className="select-filter-request focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
              onChange={(e) =>
                setFilters({ ...filters, periodo: e.target.value })
              }
              value={filters.periodo}
            >
              <option value="">Todos</option>
              <option value="trintaDias">Último 30 dias</option>
              <option value="quinzeDias">Últimos 15 dias</option>
              <option value="seteDias">Últimos 7 dias</option>
              <option value="hoje">Hoje</option>
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel className="mt-4 pl-1">Tema da Solicitação</FormLabel>
            <Select
              size="lg"
              className="select-filter-request focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
              onChange={(e) => setFilters({ ...filters, tipoSolicitacao: parseInt(e.target.value) })}
              value={filters.tipoSolicitacao}
            >
              <option value="">Todos</option>
              <option value="1">Cadastro Recebedor</option>
              <option value="2">Cadastro Emissor</option>
              <option value="3">Atualização Recebedor</option>
              <option value="4">Atualização Emissor</option>
              <option value="5">Limite Crédito</option>
              <option value="6">Conversão de Prospect</option>
            </Select>
          </FormControl>
        </div>
        <button
          className="flex-shrink-0 flex items-center gap-4 ml-auto
            mt-4 cursor-pointer"
          onClick={() => {
            cleanFilters();
            setInternalValue("");
          }}
        >
          <span className="font-semibold text-lg cursor-pointer">Limpar Filtros</span>
          <CleanFiltersIcon />
        </button>
      </div>
      <div className="flex items-center justify-between mt-[28px] mb-[24px]">
        {!loading && (
          <p className="flex-shrink-0 hidden md:block">
            Exibindo {totalList} de {total}
          </p>
        )}
        {loading && (
          <p className="flex items-center gap-2 text-sm">
            <Spinner size={"sm"} />
            Verificando se há atualizações nas requisições
          </p>
        )}
        <InputGroup className="ml-auto flex-grow-0 flex-shrink-1 md:basis-1/4">
          <p className="flex-grow-0 flex-shrink-0 mb-0 mr-2">Ordenar por:</p>
          <Select
            variant="unstyled"
            className="w-auto font-bold focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
            onChange={(e) => setFilters({ ...filters, order: e.target.value })}
            value={filters.order}
          >
            <option value="">Padrão</option>
            <option value="recentes">Mais recentes</option>
            <option value="asc">Mais antigos</option>
            {/* <option value="desc">Decrescente</option> */}
          </Select>
        </InputGroup>
      </div>
    </>
  );
};

export default RequestFilter;
